import { AccessorsMutatorsDecorator, Model } from '../../../helpers';
import { ExpensesItem } from '../expenses-item.model';

export class ExpensesPayment extends Model {

    /**
     * @param {Object|ExpensesItem} value
     * @returns {ExpensesItem}
     */
    setExpensesItem(value) {

        return value instanceof ExpensesItem ? value : new ExpensesItem(value);
    }
}

AccessorsMutatorsDecorator(
    'id',
    'property_id',
    'date',
    'time',
    'date_time',
    'expenses_item_id',
    'expenses_item',
    'paid_to',
    'purpose',
    'amount',
    'payment_method',
    'bank_id',
    'reference',
    'apply_vat',
    'vendor_id',
    'notes',
    'created_at',
    'supplier',
    'cash_drawer_id',
    'transaction_id'
)(ExpensesPayment);


// WEBPACK FOOTER //
// ./src/pms-api/models/vouchers/expenses-payment.model.js